// @flow
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import type { State } from 'types/redux';
import type { Props } from './VehiclePanel';

// Components
import VehiclePanel from './VehiclePanel';

// Selectors
import { getDealerCountryCode } from 'store/reducers/dealerSettings/selectors';
import {
  getModelLabelOther,
  getMakeLabelOther
} from 'store/reducers/userInteractions/selectors';

const mapStateToProps = (state: State): $Shape<Props> => ({
  dealerCountryCode: getDealerCountryCode(state),
  modelLabelOther: getModelLabelOther(state),
  makeLabelOther: getMakeLabelOther(state)
});

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    null
  )
)(VehiclePanel);



// WEBPACK FOOTER //
// ./src/components/atoms/VehiclePanel/VehiclePanelContainer.js